import { FlywireIframe } from "./Flywire/FlywireIframe/FlywireIframe";
import React, { useEffect } from "react";
import { usePaymentGateway } from "./shared/hooks/usePaymentGateway";

export const PaymentGateway = ({ paymentPlanLine }) => {
  const { paymentToken, getPaymentTokenByPaymentPlanLineId } =
    usePaymentGateway(paymentPlanLine.id);

  useEffect(() => {
    getPaymentTokenByPaymentPlanLineId();
  }, []);

  if (!paymentToken) return <></>;

  return (
    <FlywireIframe
      paymentToken={paymentToken}
      paymentPlanLine={paymentPlanLine}
    />
  );
};
